import React from 'react';
import PropTypes from 'prop-types';
import { getInitials } from '../utils/MyInvoices.utils';

// ============================================================================
// Subcomponents - MyInvoices Specific Components
// ============================================================================

/**
 * MyInvoiceSellerHeader - Displays seller avatar, name, and type header
 * Shows the currently selected seller with avatar initials and seller type info
 * @param {Object} selectedSeller - Selected seller object with sellerName and companySellerName
 * @param {boolean} isLoading - Whether data is currently loading
 */
export const MyInvoiceSellerHeader = ({
    selectedSeller = null,
    isLoading = false,
}) => {
    // Extract seller type from companySellerName (e.g., "THE JUMBLE WORDS/THE JUMBLE WORDS" → "THE JUMBLE WORDS")
    const getSellerType = (companySellerName) => {
        if (!companySellerName) return 'Seller';
        return companySellerName.split('/')[0] || 'Seller';
    };

    return (
        <div
            data-testid="my-invoice-seller-header"
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '16px 20px',
                backgroundColor: '#ffffff',
                borderBottom: '1px solid #f0f0f0',
                marginBottom: '20px',
                opacity: isLoading ? 0.6 : 1,
                marginTop: '-16px'
            }}
        >
            {/* Seller Info */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                {/* Avatar */}
                <div
                    data-testid="seller-avatar"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#0052CC',
                        borderRadius: '8px',
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: '600',
                        flexShrink: 0,
                    }}
                >
                    {getInitials(selectedSeller?.sellerName)}
                </div>
                {/* Info */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div
                        data-testid="seller-name"
                        style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#000',
                        }}
                    >
                        {selectedSeller?.sellerName || 'No Seller'}
                    </div>
                    <div
                        style={{
                            fontSize: '14px',
                            color: '#666',
                            fontWeight: '400',
                        }}
                    >
                        Seller: {getSellerType(selectedSeller?.companySellerName)}
                    </div>
                </div>
            </div>
        </div>
    );
};

MyInvoiceSellerHeader.propTypes = {
    selectedSeller: PropTypes.shape({
        sellerName: PropTypes.string,
        companySellerName: PropTypes.string,
    }),
    isLoading: PropTypes.bool,
};
